export default {
	alerts: [],
	error: null,
};
